import { Failed } from '../components/pages/ErrorPages/Status';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import { newrelic } from '../utils/newrelic';


interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // console.log("Error Boundary...\n ", error, errorInfo);
    // console.error("Error Boundary...\n ", error, errorInfo);
    // this.setState({ error, errorInfo });
    // dev-only console output
    if (process.env.NODE_ENV === 'development' || window.location.search.includes('version=dev')) {
      console.error('Error Boundary:', error, errorInfo);
    }

    // always send sanitized telemetry
    logErrorToMyService(error, errorInfo.componentStack);
    this.setState({ error, errorInfo });  
}

render() {
  if (this.state.hasError) {
    // You can render a fallback UI here
    return <Failed error={this.state.error} errorInfo={this.state.errorInfo} />;

  }

  return this.props.children;
}
}

export default ErrorBoundary;

// Placeholder for the logErrorToMyService function, replace it with your actual error logging implementation
function logErrorToMyService(error: Error, componentStack: string | null | undefined) {
  try {
    const incomingError = new Error(error.message);
    const currentUrl = window.location.href;
    const errorStack = error.stack;
    newrelic.addPageAction?.('error.caught', { message: incomingError.message, componentStack });
       newrelic.setApplicationVersion?.(process.env.REACT_APP_VERSION || 'Not Set');
       newrelic.setCurrentRouteName?.(currentUrl);
       newrelic.setCustomAttribute?.('errorStack', errorStack);
       newrelic.setCustomAttribute?.('errorUrl', currentUrl);
       newrelic.setCustomAttribute?.('time', new Date().toISOString());
       newrelic.noticeError?.(incomingError);
  } catch (e) {
    console.log(e)
  }
}